import React, { useState } from "react";
import { getInitials } from "../lib/utils.fmt";

/**
 * Product photo with a graceful fallback: when `src` is empty OR fails to
 * load (broken URL), shows the product's initials centered in a themed
 * circular badge instead of a bare `<img>` — which browsers otherwise
 * render as a broken-image icon + the raw `alt` text spilling into the box.
 */
export default function ProductImage({ src, name, primary = "#3A86FF", className = "", badgeClassName = "w-12 h-12 text-sm" }) {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;

  return (
    <div className={className}>
      {showPlaceholder ? (
        <div className="w-full h-full flex items-center justify-center" style={{ background: `${primary}14` }}>
          <div
            className={`rounded-full flex items-center justify-center font-heading font-extrabold text-white ${badgeClassName}`}
            style={{ background: primary }}
          >
            {getInitials(name)}
          </div>
        </div>
      ) : (
        <img
          src={src}
          alt={name}
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
